import IcFileDoc from "./doc.png";
import IcFileDefault from "./file.png";
import IcH5P from "./h5p.png";
import IcFileJPG from "./jpg.png";
import IcFileVideo from "./mov.png";
import IcFileAudio from "./mp3.png";
import IcFilePDF from "./pdf.png";
import IcFilePNG from "./png.png";
import IcFilePPT from "./ppt.png";
import IcFileTXT from "./txt.png";
import IcFileExcel from "./xls.png";

export {
  IcFileAudio,
  IcFileDoc,
  IcFileExcel,
  IcFileJPG,
  IcFilePDF,
  IcFilePPT,
  IcFileTXT,
  IcFileVideo,
  IcFileDefault,
  IcH5P,
  IcFilePNG,
};
